import React from 'react';
import AccountNewPaymentMethod from './components/AccountNewPaymentMethod.js';
import connect from './connect';
import './assets/AccountNewPaymentMethod.css';
import { Elements } from 'react-stripe-elements'; 


const Component = connect(AccountNewPaymentMethod);

const ComponentWithElements = (props) => (
  <Elements>
    <Component {...props} />
  </Elements>
);

export default ComponentWithElements;




// WEBPACK FOOTER //
// ./src/routes/AccountNewPaymentMethod/index.js